/* eslint semi:0 */
import m from 'mithril'
import BaseView from 'views/BaseView'
import { bem, node, } from 'utils/dom'

let headerContainerNode = null

const searchInputSelector = '.search-comp__input'
let searchInputNode = null

export default class GoogleSearchView extends BaseView {

  view(ctrl){
    const { vm, } = ctrl
    const { isExpandedView, } = vm.options.store
    const componentClass = isExpandedView ? 'expanded' : ''
    headerContainerNode = headerContainerNode || node('.header-container')
    headerContainerNode.className = `${ bem('header-container')({ searching: isExpandedView, }) }`
    return [
      m(
        "form.search-comp__form[method='get']",
        {
          onclick: function onSearchClick(e){
            if (!isExpandedView) {
              searchInputNode = searchInputNode || this.querySelector(searchInputSelector)
              searchInputNode.focus()
            }
          },
          onsubmit: vm.search.bind(vm),
          class: componentClass,
        },
        [
          m(
            `input${ searchInputSelector }[type='text']`,
            {
              onchange: m.withAttr("value", vm.searchboxValue),
            }
          ),
          m("button.search-comp__button[type='submit']"),
        ]
      ),
      m("gcse:searchresults-only[linktarget='_self']"),
    ]
  }

}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/GoogleSearchView.js